import { useState, useEffect } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import InputBase from '@mui/material/InputBase'
import Paper from '@mui/material/Paper'
import { SearchSVG, ClearSVG, CloseSVG } from 'components/common/SVGElements'
import styled from '@emotion/styled'
import { headerHeight } from 'config/theme'
// import {
//   useAdvancedFilterItems,
//   useServiceClassification,
// } from 'utils/api/hooks'
// import TextCheckboxButton from './TextCheckboxButton'
// import TextField from 'components/common/TextField'
// import Divider from '@mui/material/Divider'
// import FormControl from '@mui/material/FormControl'
// import { debounce, isNumber } from 'lodash-es'

const Wrapper = styled.div`
  max-height: calc(100vh - ${headerHeight});
  overflow-y: auto;
`

const ClearText = styled.div`
  ${({ theme }) => `
    font-size: 1rem;
    cursor: pointer;
    color: ${theme.palette.text.primary};
  `}
  text-decoration: ${({ isLarge }) => (isLarge ? 'underline' : 'none')};
`

const InputPaper = styled(Paper)`
  ${({ theme }) => `
    padding: 12px 15px;
    display: flex;
    align-items: center;
    flex: 1;
    border-color: ${theme.palette.background.line};
  `}
`

const SearchInput = styled(InputBase)`
  flex: 1;
  font-size: 16px;
  color: ${({ theme }) => theme.palette.primary.main};
  margin-left: ${({ theme }) => theme.spacing(2)};

  & .MuiInputBase-input {
    padding: 0;
    ::placeholder {
      color: ${({ theme }) => theme.palette.text.secondary};
      opacity: 1;
    }
  }
`

const Sticky = styled.div`
  position: sticky;
  top: 0px;
  z-index: 10;
  background-color: white;
`

const AdvanceFilters = ({
  serviceClassificationName,
  onRemoveFilteredName,
  dispatch,
  isLarge,
  onClose,
  onSubmitNameInput,
  isVisible,
  // serviceClassification,
  // advancedFilterItems,
}) => {
  /* 進階篩選-服務方案 */

  // const { data: filterItemInfos } = useAdvancedFilterItems(() =>
  //   serviceClassification ? { serviceClassification, limit: 200 } : null
  // )

  // const { data: classification } = useServiceClassification(
  //   serviceClassification
  // )

  // const filterItemSet = useMemo(() => {
  //   return new Set(advancedFilterItems || [])
  // }, [advancedFilterItems])

  // const onAdvancedFilterItemToggle = (item) => {
  //   dispatch({ type: 'TOGGLE_ADVANCED_FILTER_ITEM', payload: item._id })
  // }

  // const [budgetText, setBudgetText] = useState(
  //   (state.customerBudget || '').toString()
  // )
  // const debounceDispatch = useCallback(debounce(dispatch, 500), [dispatch])
  // const onCustomerBudgetChange = (e) => {
  //   setBudgetText(e.target.value)
  //   debounceDispatch({ type: 'SET_CUSTOMER_BUDGET', payload: e.target.value })
  // }

  // useEffect(() => {
  //   if (isNumber(state.customerBudget))
  //     setBudgetText(state.customerBudget.toString())
  //   if (!isNumber(state.customerBudget) && budgetText?.length) {
  //     setBudgetText('')
  //   }
  // }, [state.customerBudget])

  const [nameInput, setNameInput] = useState(serviceClassificationName || '')

  const onNameChange = (e) => {
    setNameInput(e.target.value)
  }

  const clearNameInput = () => setNameInput('')

  const onSubmit = () => {
    dispatch({ type: 'SET_FILTER_NAME', payload: nameInput })
  }

  useEffect(() => {
    if (serviceClassificationName !== nameInput) {
      setNameInput(serviceClassificationName || '')
    }
  }, [serviceClassificationName])

  useEffect(() => {
    if (onSubmitNameInput) {
      onSubmitNameInput(nameInput)
    }
  }, [nameInput])

  return (
    <Wrapper>
      <Sticky>
        <Box
          display="flex"
          justifyContent="space-between"
          mt={isLarge && isVisible ? 6 : 0}
        >
          {!isLarge ? (
            <CloseSVG onClick={onClose} sx={{ cursor: 'pointer' }}></CloseSVG>
          ) : null}
          <Typography variant="titleLarge" mb={6}>
            篩選
          </Typography>
          <ClearText onClick={onRemoveFilteredName} isLarge={isLarge}>
            清除
          </ClearText>
        </Box>
      </Sticky>
      <Typography variant="paraTitleSmall" mb={4}>
        廠商關鍵字
      </Typography>

      <InputPaper variant="outlined">
        <SearchSVG color="#9B9B9B" />
        <SearchInput
          sx={{ typography: 'bodyMedium' }}
          placeholder="請輸入廠商關鍵字"
          value={nameInput}
          inputProps={{ maxLength: 256 }}
          onChange={onNameChange}
          onKeyPress={(e) => {
            if (e.key === 'Enter') onSubmit()
          }}
        />
        {nameInput && (
          <Box
            display="flex"
            alignItems="center"
            px={1}
            onClick={clearNameInput}
            sx={{ cursor: 'pointer' }}
          >
            <ClearSVG />
          </Box>
        )}
      </InputPaper>
      {/* <Divider />
      <Typography variant="body2" fontWeight="fontWeightBold" mb={4}>
        您的預算
      </Typography>

      <TextField
        type="number"
        placeholder="請依輸入您的預算金額"
        fullWidth
        value={budgetText}
        onChange={onCustomerBudgetChange}
      />

      <Typography variant="caption" color="textSecondary" mt={2} mb={6}>
        單位：萬
      </Typography>

      <Divider />

      {!!filterItemInfos?.length && (
        <>
          <Typography variant="body2" fontWeight="fontWeightBold" my={6}>
            您所需的{classification?.advancedFilterTitle}
          </Typography>

          <FormControl fullWidth component="fieldset">
            {filterItemInfos.map((item) => (
              <Box mb="1px" key={item._id} width="100%">
                <TextCheckboxButton
                  fullWidth
                  checked={filterItemSet.has(item._id)}
                  onClick={() => onAdvancedFilterItemToggle(item)}
                >
                  {item.name}
                </TextCheckboxButton>
              </Box>
            ))}
          </FormControl>

          <Box mt={6} />

          <Divider />
        </>
      )} */}
    </Wrapper>
  )
}

export default AdvanceFilters
